import { defaultTheme, Icons, Progress } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { RespFile } from 'modules/domain/types'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import Lightbox, { Slide } from 'yet-another-react-lightbox'
import Counter from 'yet-another-react-lightbox/plugins/counter'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/counter.css'
import Video from 'yet-another-react-lightbox/plugins/video'
import 'yet-another-react-lightbox/styles.css'
import { AButton, ARouterLink } from 'views/components/Analytics'
import { TruncatedValue } from 'views/components/TruncatedValue/TruncatedValue'
import { sutableVideoExtensions } from 'views/pages/Bid/BidDetail/Bid/Samples/PublishSample/FIlesControl/FilesControl'

const FileItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0 8px;
`
const IconClip = styled(Icons.IconClip)`
  height: 18px;
  width: 18px;
  path {
    fill: ${defaultTheme.color.secondaryPlaceholder3};
  }
`

export const FileListComponent = ({
  deleteFile,
  files,
  deleteProgress,
}: {
  deleteFile: (id: string) => void
  files: RespFile[] | undefined
  deleteProgress: Progress
}) => {
  const [visible, setVisible] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [filesForRender, setFilesForRender] = useState<Slide[]>([])
  const onFileClick = (e: React.MouseEvent, fileId: number) => {
    e.preventDefault()
    setActiveIndex(fileId)
    setVisible(true)
  }
  useEffect(() => {
    if (files && files.length > 0) {
      const forRender = files.map((file) => {
        if (sutableVideoExtensions.includes(file.extension || '')) {
          return {
            type: 'video' as const,
            sources: [
              {
                src: file.uploaded_file,
                type: 'video/mp4',
              },
            ],
          }
        }
        return {
          src: file.uploaded_file,
        }
      })
      setFilesForRender(forRender)
    }
  }, [files])
  if (!files || files.length === 0) return null
  return (
    <div style={{ width: '100%' }}>
      {files.length
        ? files.map((file, index) => (
            <FileItem key={file.id}>
              <IconClip />
              <ARouterLink onClick={(e) => onFileClick(e, index)} eventName={`fileLinkClick-${file.id}`} to={''}>
                <TruncatedValue hint={file.original_filename}>{file.original_filename}</TruncatedValue>
              </ARouterLink>
              <AButton
                Icon={Icons.IconDelete}
                color="secondary"
                background="none"
                size="medium"
                id="deleteFile"
                onClick={() => deleteFile(file.id.toString())}
                progress={deleteProgress}
              />
            </FileItem>
          ))
        : DASH}

      <Lightbox
        plugins={[Video, Counter]}
        counter={{ container: { style: { top: 'unset', bottom: 0 } } }}
        open={visible}
        index={activeIndex}
        close={() => setVisible(false)}
        slides={filesForRender}
      />
    </div>
  )
}
